const StretchCenter = ({ children }) => {
  return (
    <div className="h-full items-center flex place-content-center	">
      <div className="flex-initial w-11/12 inline-block align-middle">{children}</div>
    </div>
  );
};

export default StretchCenter;
